import React from 'react'

const Car = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="40" cy="40" r="40" fill="white" />
            <path
                d="M34.239 55.4468C36.3786 55.4468 38.1132 53.4644 38.1132 51.0191C38.1132 48.5738 36.3786 46.5914 34.239 46.5914C32.0993 46.5914 30.3647 48.5738 30.3647 51.0191C30.3647 53.4644 32.0993 55.4468 34.239 55.4468Z"
                fill="#EF8078"
            />
            <path
                d="M56.3773 55.4468C58.5169 55.4468 60.2515 53.4644 60.2515 51.0191C60.2515 48.5738 58.5169 46.5914 56.3773 46.5914C54.2376 46.5914 52.5031 48.5738 52.5031 51.0191C52.5031 53.4644 54.2376 55.4468 56.3773 55.4468Z"
                fill="#EF8078"
            />
            <path
                d="M21.5094 33.3082H9.33331"
                stroke="#686058"
                strokeLinejoin="round"
            />
            <path
                d="M23.2764 45.6045L26.3341 26.9358C29.4524 26.2597 47.6378 26.6936 51.965 30.1448C53.98 31.7543 54.9573 35.0188 56.66 35.9422C58.5239 36.9513 60.6547 37.3398 62.6445 38.0714C69.1329 40.4731 67.5108 47.658 67.5108 47.658C68.3067 48.4502 68.1002 51.7651 67.1179 51.7651L61.6119 51.8408C61.6119 53.0907 61.1161 54.2893 60.2338 55.1731C59.3514 56.0569 58.1547 56.5534 56.9068 56.5534C55.659 56.5534 54.4622 56.0569 53.5799 55.1731C52.6975 54.2893 52.2018 53.0907 52.2018 51.8408H39.8095C39.8095 53.0907 39.3138 54.2893 38.4314 55.1731C37.5491 56.0569 36.3523 56.5534 35.1045 56.5534C33.8566 56.5534 32.6599 56.0569 31.7775 55.1731C30.8951 54.2893 30.3994 53.0907 30.3994 51.8408L22.6668 51.7702C22.4603 51.7399 22.954 48.3493 22.954 48.3493"
                stroke="#686058"
                strokeLinejoin="round"
            />
            <path
                d="M15.9747 43.2705H20.4024"
                stroke="#686058"
                strokeLinejoin="round"
            />
            <path
                d="M13.761 38.8424H21.5095"
                stroke="#686058"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default Car
